interface ArgoCDApplicationSourceResourceBase {
    Index: number;
    ProjectId: string | null;
    EnvironmentId: string | null;
    TenantId: string | null;
    RepositoryUrl: string;
    Name: string | null;
    TargetRevision: string;
    RequiresGitCredential: boolean;
    BestMatchedGitCredentialId: string | null;
}
export type ArgoCDApplicationSourceResource = ArgoCDDirectoryApplicationSourceResource | ArgoCDHelmApplicationSourceResource | ArgoCDRefApplicationSourceResource;
export interface ArgoCDDirectoryApplicationSourceResource extends ArgoCDApplicationSourceResourceBase {
    Path: string;
}
export interface ArgoCDHelmApplicationSourceResource extends ArgoCDApplicationSourceResourceBase {
    Path: string;
    ValueFiles: string[];
}
export interface ArgoCDRefApplicationSourceResource extends ArgoCDApplicationSourceResourceBase {
    Ref: string;
}
export function isHelmApplicationSource(source: ArgoCDApplicationSourceResource): source is ArgoCDHelmApplicationSourceResource {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (source as ArgoCDHelmApplicationSourceResource)?.ValueFiles !== undefined;
}
export function isRefApplicationSource(source: ArgoCDApplicationSourceResource): source is ArgoCDRefApplicationSourceResource {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (source as ArgoCDRefApplicationSourceResource)?.Ref !== undefined;
}
